// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"HK-z","carousel":"IK-z"};